<script>
import QuestionList from './QuestionList';

export default {
  name: 'CategoryList',
  components: {
    QuestionList,
  },
  props: {
    categories: {
      type: Array,
      required: false,
      default: () => [],
    },
    privacyAuditId: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      // categories: categories,
      // privacyAuditId: privacyAuditId,
    };
  },
  computed: {
    sortedCategories() {
      const c = this.categories ? _.orderBy(this.categories, 'id') : []; // eslint-disable-line

      return c;
    },
  },
  created() {
    this.localDisabled = this.disabled;
  },
};
</script>

<template>
  <div>
    <v-container fluid grid-list-lg pt-2 pa-2>
      <v-layout row wrap>
        <v-flex md12>
          <!-- eslint-disable -->
          <i v-if="sortedCategories.length > 0">Hinweis: Fragen werden bei der Auswahl automatisch gespeichert.</i>
          <i v-else>Sie haben keine Fragenkategorien für dieses Audit ausgewählt. Bitte öffnen Sie den Reiter AUDIT-DATEN und treffen Sie unter Relevante Kategorien Ihre Auswahl.</i>
          <!-- eslint-enable -->
        </v-flex>
      </v-layout>
    </v-container>

    <v-expansion-panel>
      <v-expansion-panel-content
        v-for="category in sortedCategories"
        :key="category.id"
      >
        <div slot="header">{{ category.translatedName }}</div>
        <v-card>
          <v-card-text>
            <question-list
              :category-id="category.id"
              :privacy-audit-id="privacyAuditId"
              :disabled="localDisabled"
            />
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>
